import { createAction, props } from "@ngrx/store";
import { CardActionDTO } from "src/app/models/pos-cards/posCardsDTO";

export const getPosCards = createAction(
  "[POS] Get All POS Cards Action",
  props<{ options: any }>()
);
export const loadPosCards = createAction(
  "[POS] Load All POS Cards Action",
  props<{ response: CardActionDTO[] }>()
);
export const getExcelPosCards = createAction(
  "[POS] Get All Excel POS Cards Action",
  props<{ options: any }>()
);
export const loadExcelPosCards = createAction(
  "[POS] Load All Excel POS Cards Action",
  props<{ response: CardActionDTO[] }>()
);
export const getPosCard = createAction(
  "[POS] Get POS Card Action",
  props<{ code: string }>()
);
export const loadPosCard = createAction(
  "[POS] Load POS Card Action",
  props<{ response: any }>()
);
export const setLoadingEndState = createAction(
  "[POS] Set POS Cards Loading End State Action"
);
export const resetPosCardsState = createAction(
  "[POS] Reset POS Cards State Action"
);
// Table Configuration Settings
export const getPosCardsTableConfig = createAction(
  "[POS] Get POS Cards Table Configuration Action",
  props<{ options: any }>()
);
export const loadPosCardsTableConfig = createAction(
  "[POS] Load POS Cards Table Configuration Action",
  props<{ response: any[] }>()
);
export const savePosCardsTableConfig = createAction(
  "[POS] Save POS Cards Table Configuration Action",
  props<{ config: any }>()
);

export const resetPosCard = createAction("[POS] Reset Pos Card Action");
